module.exports = __webpack_public_path__ + "img/3-min.0d6a3218.jpg";